import types from './types';

export const loadPopups = () => async dispatch => {
    setTimeout(() => {
        dispatch({
            type: types.loaded
        });
    }, 3e3);
}

export const popupClose = id => async dispatch => {
    return dispatch({
        type: types.hide,
        payload: id
    });
}

export const popupClick = id => async dispatch => {
    return dispatch({
        type: types.hide,
        payload: id
    });
}